/***
 * Created on 2023/7/10
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';
import ContactTable from "./contact_table";
import {QueryClient, useQuery, QueryClientProvider} from "@tanstack/react-query";
import {apiGet} from "../../service/api";
import ContactFooter from "./contact_footer";
import AddContactDialog from "./add_contact_dialog";
import sharedI18n from "common/SharedI18n";
import {I18nextProvider, useTranslation} from "react-i18next";
import {useLanguage} from 'common/Hook';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});

function Contact(props) {
    const [showAddContact, setShowAddContact] = useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState("");
    const [result, setResult] = useState([]);
    const { t, i18n } = useTranslation();
    useLanguage(i18n);

    const friends = useQuery({
        queryKey: ['friend', page, pageSize],
        queryFn: async () => await apiGet(`/ajax/friend?offset=${pageSize*(page)}&limit=${pageSize}&return_total=true`),
        refetchOnWindowFocus: false
    });

    const onSearchChanged = (e) => {
        setSearch(e.target.value);
        setResult((prev) => {
            if (!e.target?.value) return friends.data.data;

            const list = friends?.data?.data.filter(friend => {
                const test = friend?.nickname?.includes(e.target.value) || friend?.email?.includes(e.target.value)
                return test;
            });
            console.log(list);
            return list;
        });
    }

    const clearSearch = (e) => {
        e.target.value = "";
        onSearchChanged(e);
    }

    useEffect(() => {
        if (friends.data && friends.isSuccess) {
            setTotal(friends.data.total);
            setResult(friends.data.data);
        }
    }, [friends.data, friends.isSuccess]);

    return (
        <section className="page-wrapper">

            {
                showAddContact &&
                <AddContactDialog
                    title={t('@Add to contact list@')}
                    showModal={showAddContact} closeModal={() => setShowAddContact(false)}/>
            }

            <header className="page-header">{t('@Contact List@')}</header>
            <div className="page-toolbar !pt-0">
                <div className="comp-toolbar">
                    <div className="toolbar">
                        <div className="toolbar__col-left" data-rwd-flex-initial={''} data-rwd-minimize={''}>
                            <div className="amount-info">
                                <span className="amount-info__label display-inline-block !mr-8">聯絡人</span>
                                <span className="amount-info__amount display-inline-block">
                                    <span className="display-inline-block text-20 font-medium color-primary">{result?.length}</span>
                                    {/*<span className="display-inline-block text-20 font-medium color-primary">{friends?.data?.data?.length}</span>*/}
                                    <span className="display-inline-block text-16 ml-4 mr-4">/</span>
                                    <span className="display-inline-block text-16">{total}</span>
                                </span>
                            </div>
                            <div className="toolbar__col-divide" />
                            <button className="q-btn q-btn--primary q-btn--hybrid btn-rounded-full" onClick={()=>setShowAddContact(true)}>
                                <span className="q-btn__icon" ic-type="add" />
                                <span className="q-btn__label">{t('@Add@')}</span>
                            </button>
                        </div>
                        <div className="toolbar__col-right" rwd-flex-1={''}>
                            <div className="comp-input">
                                <div className="input-field--wrapper">
                                    <div className="input-field--search">
                                        <div className="input-field--search__form">
                                            <input type="text" placeholder={t("@Search@")} className="round-full" value={search} onChange={onSearchChanged}/>
                                            <span className="input-ic--search"></span>
                                            <span className="input-toggle--clear" onClick={e=>clearSearch(e)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="page-body">
                <div className="page-content page-content--contacts">
                    {result && <ContactTable data={result} />}
                    {/*{friends?.data?.data && <ContactTable data={friends?.data?.data} />}*/}
                </div>
            </section>

            <ContactFooter page={page} setPage={setPage} total={total} pageSize={pageSize} setPageSize={setPageSize}/>
        </section>
    );
}

function ContactIndex(props) {
    return (
        <I18nextProvider i18n={sharedI18n}>
            <QueryClientProvider client={queryClient}>
                <Contact />
            </QueryClientProvider>
        </I18nextProvider>
    );
}

export default ContactIndex;